import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./RoomLayout.scss";
import { Toolbar } from "./Toolbar";
import { ToolbarProvider } from "../contexts/ToolbarContext";
import configManager from "../../singleton/ConfigManager";
import { Badge, Card } from "@fluentui/react-components";
import { Notch } from "../room/Notch";

export function RoomLayout({
  className,
  viewportClassName,
  sidebar,
  sidebarClassName,
  sidebarLeft,
  toolbarLeft,
  toolbarCenter,
  toolbarRight,
  toolbarClassName,
  modal,
  viewport,
  objectFocused,
  isNotAbsolute,
  streaming,
  viewportRef,
  toggleStreamerMode,
  showToolbar = true,
  renderEntryFlow,
  hubChannel,
  signedIn,
  ...rest
}) {
  const showVerseSettings =
    configManager.config.roomEntryDialog?.roomSettings?.enabled &&
    hubChannel &&
    hubChannel.canOrWillIfCreator("update_hub") &&
    signedIn;

  const stylesStreamingCard = {
    borderTopLeftRadius: "0px",
    borderTopRightRadius: "0px",
    display: "flex",
    justifyContent: "flex-end",
    minWidth: "84px",
    flexDirection: "row",
    paddingTop: "9px",
    paddingBottom: "9px"
  };

  return (
    <div className={classNames(styles.roomLayout, { [styles.objectFocused]: objectFocused }, className)}>
      {sidebar && (
        <div
          className={classNames(styles.sidebarContainer, {
            [styles.isNotAbsolute]: isNotAbsolute,
            [styles.sidebarLeft]: sidebarLeft
          })}
        >
          <div className={classNames(styles.sidebar, sidebarClassName)}>{sidebar}</div>
        </div>
      )}
      <div className={classNames(styles.modalContainer, styles.viewport)}>{modal}</div>
      <div
        className={classNames(styles.main, styles.viewport, viewportClassName, "RoomLayoutViewport")}
        ref={viewportRef}
      >
        {streaming && (
          <div className={styles.streamingOverlay}>
            <Notch spaced onClose={toggleStreamerMode}>
              <Badge size="extra-small" color="danger" className={styles.streamingBadge} />
            </Notch>
          </div>
        )}

        {viewport}
        <ToolbarProvider canSpawnEmojis={hubChannel && hubChannel.can("spawn_emoji")}>
          {!renderEntryFlow && showToolbar && (
            <Toolbar
              hubChannel={hubChannel}
              signedIn={signedIn}
              showVerseSettings={showVerseSettings}
              objectFocused={objectFocused}
              toggleStreamerMode={toggleStreamerMode}
              {...rest}
            />
          )}
        </ToolbarProvider>
      </div>
    </div>
  );
}

RoomLayout.propTypes = {
  className: PropTypes.string,
  viewportClassName: PropTypes.string,
  sidebar: PropTypes.node,
  sidebarClassName: PropTypes.string,
  sidebarLeft: PropTypes.bool,
  toolbarLeft: PropTypes.node,
  toolbarCenter: PropTypes.node,
  toolbarRight: PropTypes.node,
  toolbarClassName: PropTypes.string,
  modal: PropTypes.node,
  viewport: PropTypes.node,
  objectFocused: PropTypes.bool,
  streaming: PropTypes.bool,
  viewportRef: PropTypes.any,
  toggleToolbar: PropTypes.node,
  showToolbar: PropTypes.bool,
  isNotAbsolute: PropTypes.bool,
  hubChannel: PropTypes.object,
  signedIn: PropTypes.bool,
  renderEntryFlow: PropTypes.bool,
  toggleStreamerMode: PropTypes.func
};
